
import genericService from '../genericService';

export default {
    async loadGeneric(url, params, callback){
        await genericService.get(url, params).then(callback);
    },
    async loadGenericItem(url, id, callback){
        await genericService.getItem(url, id).then(callback);
    },
    async createItem(url, body, callback){
        await genericService.post(url, body).then(callback);
    },
    async updateItem(url, body, callback, id){
        await genericService.put(url, body, id).then(callback);
    },
    async deleteItem(url, id, callback){
        await genericService.delete(url, id).then(callback);
    },
    async deleteGeneric(url, callback){
        await genericService.deleteGeneric(url).then(callback);
    },
    async elasticSearch(query, callback){
        await genericService.getElasticSearch(query).then(callback);
    },
    async dowloadFile(url, body, callback){
        await genericService.dowloadFile(url, body).then(callback);
    },
}